var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isOpenB
      ? _c(
          "div",
          { staticClass: "test" },
          [
            _c("v-icon", { staticClass: "btnbar", on: { click: _vm.click } }, [
              _vm._v("X"),
            ]),
            _c("br"),
            _c("br"),
            _c(
              "div",
              { staticClass: "px-3 py-2" },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "FinRepo-sty",
                        attrs: { cols: "12", md: "8" },
                      },
                      [
                        _c("p", { staticClass: "table-title" }, [
                          _vm._v("Financial Report"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c("p", { staticClass: "Report-color" }, [
                  _vm._v("Service date :"),
                ]),
                _c("br"),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "FinRepo-sty",
                        staticStyle: { "margin-bottom": "-14px" },
                        attrs: { cols: "12", md: "12" },
                      },
                      [
                        _c("v-autocomplete", {
                          ref: "clientSearch",
                          attrs: {
                            multiple: "",
                            outlined: "",
                            label: "Custom date",
                            items: _vm.clients,
                            "item-text": "name",
                            "item-value": "id",
                          },
                          on: { change: _vm.handleClientFilter },
                          model: {
                            value: _vm.clientIds,
                            callback: function ($$v) {
                              _vm.clientIds = $$v
                            },
                            expression: "clientIds",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticStyle: { "margin-bottom": "-28px" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "FinRepo-sty",
                        attrs: { cols: "6", md: "6" },
                      },
                      [
                        _c("v-autocomplete", {
                          ref: "DateFrom",
                          attrs: {
                            "prepend-inner-icon": "mdi-calendar",
                            multiple: "",
                            outlined: "",
                            label: "From",
                            items: _vm.From,
                            "item-text": "name",
                            "item-value": "id",
                          },
                          on: { change: _vm.handleClientFilter },
                          model: {
                            value: _vm.clientIds,
                            callback: function ($$v) {
                              _vm.clientIds = $$v
                            },
                            expression: "clientIds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "FinRepo-sty",
                        attrs: { cols: "6", md: "6" },
                      },
                      [
                        _c("v-autocomplete", {
                          ref: "DateTo",
                          attrs: {
                            "prepend-inner-icon": "mdi-calendar",
                            multiple: "",
                            outlined: "",
                            label: "To",
                            items: _vm.To,
                            "item-text": "name",
                            "item-value": "id",
                          },
                          on: { change: _vm.handleClientFilter },
                          model: {
                            value: _vm.clientIds,
                            callback: function ($$v) {
                              _vm.clientIds = $$v
                            },
                            expression: "clientIds",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("hr"),
                _c("br"),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "reportCols",
                        attrs: { cols: "12", md: "8" },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "Report-color",
                            staticStyle: { padding: "15px" },
                          },
                          [_vm._v("Payment Type:")]
                        ),
                        _vm._v(" "),
                        _c("br"),
                      ]
                    ),
                    _c(
                      "v-col",
                      { staticClass: "pad0", attrs: { cols: "12", md: "12" } },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "reportCols",
                                staticStyle: { "margin-bottom": "-16px" },
                                attrs: { cols: "12", md: "4" },
                              },
                              [
                                _c("v-checkbox", {
                                  staticClass: "reportCols",
                                  attrs: { label: "w2", color: "#4B5568" },
                                  model: {
                                    value: _vm.isLongTerm,
                                    callback: function ($$v) {
                                      _vm.isLongTerm = $$v
                                    },
                                    expression: "isLongTerm",
                                  },
                                }),
                                _c("v-checkbox", {
                                  staticClass: "reportCols",
                                  attrs: { label: "1099", color: "#4B5568" },
                                  model: {
                                    value: _vm.isLongTerm,
                                    callback: function ($$v) {
                                      _vm.isLongTerm = $$v
                                    },
                                    expression: "isLongTerm",
                                  },
                                }),
                                _c("v-checkbox", {
                                  staticClass: "reportCols",
                                  attrs: { label: "vendor", color: "#4B5568" },
                                  model: {
                                    value: _vm.isLongTerm,
                                    callback: function ($$v) {
                                      _vm.isLongTerm = $$v
                                    },
                                    expression: "isLongTerm",
                                  },
                                }),
                                _c("v-checkbox", {
                                  staticClass: "reportCols",
                                  attrs: { label: "TEMP", color: "#4B5568" },
                                  model: {
                                    value: _vm.isLongTerm,
                                    callback: function ($$v) {
                                      _vm.isLongTerm = $$v
                                    },
                                    expression: "isLongTerm",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("br"),
                _c("hr"),
                _c("br"),
                _c(
                  "v-row",
                  [
                    _c("v-col", { attrs: { cols: "12", md: "8" } }, [
                      _c("p", { staticClass: "FinRepo-sty" }, [
                        _vm._v("Filter By technician"),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "FinRepo-sty",
                    attrs: { cols: "12", md: "12" },
                  },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c("v-autocomplete", {
                              ref: "clientSearch",
                              staticStyle: { "margin-bottom": "-29px" },
                              attrs: {
                                multiple: "",
                                outlined: "",
                                label: "TECH",
                                items: _vm.clients,
                                "item-text": "name",
                                "item-value": "id",
                              },
                              on: { change: _vm.handleClientFilter },
                              model: {
                                value: _vm.clientIds,
                                callback: function ($$v) {
                                  _vm.clientIds = $$v
                                },
                                expression: "clientIds",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("hr"),
                _c("br"),
                _c(
                  "v-row",
                  { staticStyle: { "padding-top": "3%" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "FinRepo-sty",
                        attrs: { cols: "12", md: "8" },
                      },
                      [_c("p", {}, [_vm._v("Grouped by Account")])]
                    ),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "FinRepo-sty",
                    attrs: { cols: "12", md: "12" },
                  },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "12" } },
                          [
                            _c("v-autocomplete", {
                              ref: "clientSearch",
                              attrs: {
                                multiple: "",
                                outlined: "",
                                label: "Select",
                                items: _vm.clients,
                                "item-text": "name",
                                "item-value": "id",
                              },
                              on: { change: _vm.handleClientFilter },
                              model: {
                                value: _vm.clientIds,
                                callback: function ($$v) {
                                  _vm.clientIds = $$v
                                },
                                expression: "clientIds",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "test2", attrs: { id: "fixed" } },
      [
        !_vm.isOpenB
          ? _c("v-icon", { on: { click: _vm.click } }, [
              _vm._v("fa-regular fa-bars"),
            ])
          : _vm._e(),
        _c(
          "v-btn",
          {
            staticClass: "btn-creation wo-diff-style",
            staticStyle: { float: "right" },
            attrs: { to: "/Reports/FinancialReports2" },
          },
          [_vm._v("Next Financial Report")]
        ),
        _c("span", [
          _c("table", { staticClass: "FinancialTab table table-hover" }, [
            _vm._m(0),
            _c("tbody", [
              _c("tr", [
                _c("td", { staticClass: "colscolor" }, [
                  _vm._v("Year to year report"),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(Date().substring(0, 10)) +
                      "   " +
                      _vm._s(_vm.currentDateTime())
                  ),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "colscolor" }, [
                  _vm._v("Financial Analysis Active report"),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(Date().substring(0, 10)) +
                      "   " +
                      _vm._s(_vm.currentDateTime())
                  ),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "colscolor" }, [_vm._v("Waterfall")]),
                _c("td", [
                  _vm._v(
                    _vm._s(Date().substring(0, 10)) +
                      "   " +
                      _vm._s(_vm.currentDateTime())
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", { staticStyle: { height: "50px", "text-align": "left" } }, [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Name")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Action")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }